<template>
  <div>
    <Nav></Nav>
    <b-container fluid class="mt-3">
      <ReportSearchBar :init="routeQuery.fini" :end="routeQuery.ffin" :sucursales="routeQuery.sucursales" :emitOnChange="false" @search="searchRecv" @changed="changeData"></ReportSearchBar>
      <b-row>
        <b-col>
          <h1>Compras</h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button variant="success" @click="$bvModal.show('modal-newPurchaseOrder')">Crear Compra</b-button>
          <b-button v-if="hasPermission('rrn:central:purchaseOrder:import')" variant="primary" @click="$bvModal.show('modal-bulkImportPO')">
            <i class="fas fa-file-excel mr-1"></i> Carga masiva (Excel)
          </b-button>
          <b-button variant="default" @click="getComprasPDF">Descargar 1x1</b-button>
          <b-button variant="default" @click="getComprasResumenPDF">Descargar Resumen</b-button>

        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Buscar:">
            <b-form-input type="search" v-model="routeQuery.search" @keyup="page = 1"  @blur.native="updateQuery"  debounce="500"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Stage Indicators -->
      <b-row class="mb-3">
        <b-col>
          <div class="d-flex align-items-center mb-2">
            <i class="fas fa-chart-pie text-muted mr-2" style="font-size: 0.9rem;"></i>
            <span class="text-muted" style="font-size: 0.9rem;">Estado de las Órdenes de Compra</span>
          </div>
          <b-row>
            <b-col xl="2" lg="3" md="4" sm="6" class="mb-2">
              <div class="d-flex align-items-center justify-content-center p-2 rounded" style="background: #fafafa;">
                <i class="fas fa-edit text-secondary mr-2" style="font-size: 0.85rem;"></i>
                <span class="font-weight-bold text-dark mr-1">{{ stageCounts.draft }}</span>
                <small class="text-muted">Borradores</small>
              </div>
            </b-col>
            <b-col xl="2" lg="3" md="4" sm="6" class="mb-2">
              <div class="d-flex align-items-center justify-content-center p-2 rounded" style="background: #f8f9fa;">
                <i class="fas fa-paper-plane text-secondary mr-2" style="font-size: 0.85rem;"></i>
                <span class="font-weight-bold text-dark mr-1">{{ stageCounts.sent }}</span>
                <small class="text-muted">Enviados</small>
              </div>
            </b-col>
            <b-col xl="2" lg="3" md="4" sm="6" class="mb-2">
              <div class="d-flex align-items-center justify-content-center p-2 rounded" style="background: #f5f5f5;">
                <i class="fas fa-check-circle text-secondary mr-2" style="font-size: 0.85rem;"></i>
                <span class="font-weight-bold text-dark mr-1">{{ stageCounts.confirmed }}</span>
                <small class="text-muted">Confirmados</small>
              </div>
            </b-col>
            <b-col xl="2" lg="3" md="4" sm="6" class="mb-2">
              <div class="d-flex align-items-center justify-content-center p-2 rounded" style="background: #f0f8ff;">
                <i class="fas fa-shopping-cart text-info mr-2" style="font-size: 0.85rem; opacity: 0.7;"></i>
                <span class="font-weight-bold text-dark mr-1">{{ stageCounts.purchase }}</span>
                <small class="text-muted">En Compra</small>
              </div>
            </b-col>
            <b-col xl="2" lg="3" md="4" sm="6" class="mb-2">
              <div class="d-flex align-items-center justify-content-center p-2 rounded" style="background: #e8f4fd;">
                <i class="fas fa-user-check text-info mr-2" style="font-size: 0.85rem; opacity: 0.7;"></i>
                <span class="font-weight-bold text-dark mr-1">{{ stageCounts.assigned }}</span>
                <small class="text-muted">Asignados</small>
              </div>
            </b-col>
            <b-col xl="2" lg="3" md="4" sm="6" class="mb-2">
              <div class="d-flex align-items-center justify-content-center p-2 rounded" style="background: #f0f9f0;">
                <i class="fas fa-check-double text-success mr-2" style="font-size: 0.85rem; opacity: 0.7;"></i>
                <span class="font-weight-bold text-dark mr-1">{{ stageCounts.done }}</span>
                <small class="text-muted">Completados</small>
              </div>
            </b-col>
            <b-col xl="2" lg="3" md="4" sm="6" class="mb-2">
              <div class="d-flex align-items-center justify-content-center p-2 rounded" style="background: #fef5f5;">
                <i class="fas fa-times-circle text-danger mr-2" style="font-size: 0.85rem; opacity: 0.6;"></i>
                <span class="font-weight-bold text-dark mr-1">{{ stageCounts.cancel }}</span>
                <small class="text-muted">Cancelados</small>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-table ref="selectableTable" selectable @row-selected="onRowSelected" small :filter="routeQuery.search" striped hover :items="compras" :fields="comprasLabels" responsive>
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
            <template #cell(status)="data">
              <b-badge :variant="statusBadge(data.item.status).variant">{{ statusBadge(data.item.status).text
                }}</b-badge>
            </template>
            <template #cell(buttons)="data">
              <b-button size="sm" variant="success" @click="$router.push('/compra/' + data.item.id)" class="mr-1">
                +Info
              </b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-modal id="modal-newPurchaseOrder" :hide-footer="true" size="xl" title="Crear Orden de Compra">
        <CreatePurchaseOrder @created="newPOCreated" @error="newPOError" >
        </CreatePurchaseOrder>
      </b-modal>
      <b-modal id="modal-bulkImportPO" :hide-footer="true" size="xl" title="Carga masiva de órdenes de compra">
        <BulkImportPurchaseOrders @created="bulkImportCreated" @done="bulkImportDone" @error="newPOError" />
      </b-modal>
    </b-container>

  </div>
</template>
<script>
import axios from "axios";
import Nav from "../components/Nav.vue";
import ReportSearchBar from "./reports/searchBar/ReportSearchBar.vue";
import moment from 'moment';
import CreatePurchaseOrder from "../components/CreatePurchaseOrder.vue";
import BulkImportPurchaseOrders from "../components/BulkImportPurchaseOrders.vue";
import { permissionMixin } from "../mixins/permissionMixin";
export default {
  name: "Compras",
  mixins: [permissionMixin],
  components: {
    Nav, ReportSearchBar, CreatePurchaseOrder, BulkImportPurchaseOrders
  },

  data() {
    return {
      routeQuery:{
        page:null,
        search:null,
        fini:null,
        ffin:null,
        sucursales:null
      },
      initialDate: "",
      lastDate: "",
      allSucsArray: [],
      search: "",
      compras: [],
      actualSucursal: {
        id: null
      },
      comprasLabels: [
        { key: "id", label: "ID" },
        { key: "name", label: "Nombre" },
        { key: "provider.name", label: "Proveedor" , sortable: true},
        { key: "user.name", label: "Creado Por" },
        { key: "sucursal.nombre", label: "Sucursal" , sortable: true},
        { key: "status", label: "Status" , sortable: true},
        { key: "date_create", label: "Creacion" , sortable: true},
        { key: "date_planned", label: "Entrega planeada" , sortable: true},
        { key: "buttons", label: "" }
      ]
    };
  },

  computed: {
    stageCounts() {
      const counts = {
        draft: 0,
        sent: 0,
        confirmed: 0,
        purchase: 0,
        assigned: 0,
        done: 0,
        cancel: 0
      };
      
      this.compras.forEach(compra => {
        if (Object.prototype.hasOwnProperty.call(counts, compra.status)) {
          counts[compra.status]++;
        }
      });
      
      return counts;
    }
  },
  mounted() {
    console.log("mounted")
    this.routeQuery.search=this.$route.query.search
    this.routeQuery.ffin=this.$route.query.ffin
    this.routeQuery.fini=this.$route.query.fini
    this.routeQuery.sucursales=this.$route.query.sucursales
    console.log(this.routeQuery)
  },
  created() {
    console.log("created")
  },
  methods: {
    onBlur(e){
      console.log(e)
    },
    onRowSelected(item){
      console.log(item)
      if(item.length>0){
        this.$router.push('/compra/' + item[0].id)
      }
      this.$refs.selectableTable.clearSelected()
    },
    updateQuery(){
      const pendingUpdates = { ...this.$route.query }
      Object.entries(this.routeQuery).forEach(([key, value]) => {
        if (value === null || value === undefined || value=="") {
          delete pendingUpdates[key]
        } else {
          pendingUpdates[key] = value
        }
      })
      console.log("updating")
      this.$router.replace({
        query: pendingUpdates
      })
    },
    changeData(e){
      console.log(e)
      this.routeQuery.ffin=moment(e.end).format('YYYY-MM-DD');
      this.routeQuery.fini=moment(e.init).format('YYYY-MM-DD');
      this.routeQuery.sucursales=e.sucursales.join(",");
      this.updateQuery()
    },
    searchRecv(p) {
      this.initialDate = moment(p.initDate).format('YYYY-MM-DD');
      this.lastDate = moment(p.endDate).format('YYYY-MM-DD');
      this.allSucsArray = p.sucursales
      this.getCompras()
    },
    newPOError(evt) {
      console.log("error reading")
      console.log(evt)
      this.getCompras()
      this.makeToast("danger", "Error", evt.data)
    },
    statusBadge(status) {
      let rtn = { variant: "", text: status }
      switch (status) {
        case "draft":
          rtn.variant = "warning"
          rtn.text = "Borrador"
          break;
        case "sent":
          rtn.variant = "warning"
          rtn.text = "Enviado"
          break;
        case "confirmed":
          rtn.variant = "warning"
          rtn.text = "Confirmado"
          break;
        case "purchase":
          rtn.variant = "info"
          rtn.text = "En Compra"
          break;
        case "assigned":
          rtn.variant = "info"
          rtn.text = "Asignado"
          break;
        case "done":
          rtn.variant = "success"
          rtn.text = "Hecho"
          break;
        case "cancel":
          rtn.variant = "danger"
          rtn.text = "Cancelado"
          break;
      }
      return rtn
    },
    newPOCreated(evt) {
      console.log(evt)
      this.$router.push('/compra/' + evt)
      this.getCompras()
    },
    bulkImportCreated(res) {
      this.makeToast("success", "Carga masiva", (res && res.message) || "Órdenes creadas")
      this.getCompras()
    },
    bulkImportDone() {
      this.$bvModal.hide('modal-bulkImportPO')
      this.getCompras()
    },
    getCompras() {
      let that = this
      console.log("/purchaseorders?sucursales=" + this.allSucsArray.join(",") + "&init_date=" + this.initialDate + "&end_date=" + this.lastDate)
      axios.get("/purchaseorders?sucursales=" + this.allSucsArray.join(",") + "&init_date=" + this.initialDate + "&end_date=" + this.lastDate)
        .then(function (res) {
          that.compras = res.data
        }).catch(function (err) {
          console.error(err)
        })
    },
    getComprasPDF() {
      let that = this
      let format="pdf"
      axios.get("/purchaseorders?sucursales=" + this.allSucsArray.join(",") + "&init_date=" + this.initialDate + "&end_date=" + this.lastDate+"&format=pdf", {
        "responseType": "blob",
        headers: {
          'Accept': '*/*',
        }
      })
        .then(function (response) {
          console.log(response.headers)
          console.log(response)
          const blob = new Blob([response.data]);
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          const contentDisposition = response.headers['content-disposition'];
          console.log(response.headers)
          let filename = 'downloaded_file.'+format; // Fallback filename in case the header is missing
          if (contentDisposition && contentDisposition.includes('filename')) {
            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            const matches = filenameRegex.exec(contentDisposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, ''); // Remove any surrounding quotes
            }
          }
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => that.makeToast("danger", "Error", error.response.data));

    },
    getComprasResumenPDF() {
      let that = this
      let format="pdf"
      console.log("/report/compras/resumen?sucursales=" + this.allSucsArray.join(",") + "&init_date=" + this.initialDate + "&end_date=" + this.lastDate+"&format=pdf")
      axios.post("/report/compras/resumen?sucursales=" + this.allSucsArray.join(",") + "&init_date=" + this.initialDate + "&end_date=" + this.lastDate+"&format=pdf",null, {
        "responseType": "blob",
        headers: {
          'Accept': '*/*',
        }
      })
        .then(function (response) {
          console.log(response.headers)
          console.log(response)
          const blob = new Blob([response.data]);
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          const contentDisposition = response.headers['content-disposition'];
          console.log(response.headers)
          let filename = 'downloaded_file.'+format; // Fallback filename in case the header is missing
          if (contentDisposition && contentDisposition.includes('filename')) {
            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            const matches = filenameRegex.exec(contentDisposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, ''); // Remove any surrounding quotes
            }
          }
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => that.makeToast("danger", "Error", error.response.data));

    },
    makeToast(variant = null, title = "", text = "") {
      this.$bvModal.msgBoxOk(text, {
        title: title,
        okVariant: variant,
        centered: true
      })
      // this.$bvToast.toast(text, {
      //   title: title,
      //   variant: variant,
      //   solid: true,
      //   appendToast: true,
      // });
    },
  },
};
</script>

<style scoped>
.stage-card {
  transition: all 0.3s ease;
  cursor: default;
  min-height: 120px;
  border-radius: 12px !important;
}

.stage-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0,0,0,0.15) !important;
}

.stage-card .card-body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
}

.stage-card h2 {
  font-size: 2.2rem;
  text-shadow: 1px 1px 2px rgba(0,0,0,0.1);
}

.stage-card i {
  filter: drop-shadow(1px 1px 2px rgba(0,0,0,0.1));
}

.stage-card small {
  font-size: 0.75rem;
  letter-spacing: 0.5px;
}

@media (max-width: 768px) {
  .stage-card h2 {
    font-size: 1.8rem;
  }
  
  .stage-card i {
    font-size: 1.5rem !important;
  }
  
  .stage-card .card-body {
    padding: 1rem 0.5rem !important;
  }
}

@media (max-width: 576px) {
  .stage-card {
    margin-bottom: 1rem;
    min-height: 100px;
  }
  
  .stage-card h2 {
    font-size: 1.5rem;
  }
  
  .stage-card i {
    font-size: 1.2rem !important;
    margin-right: 0.5rem !important;
  }
}
</style>
